import React from 'react';

const PoiMarker: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 11.5C13.1569 11.5 14.5 10.1569 14.5 8.5C14.5 6.84315 13.1569 5.5 11.5 5.5C9.84315 5.5 8.5 6.84315 8.5 8.5C8.5 10.1569 9.84315 11.5 11.5 11.5ZM18.5 8.5C18.5 4.6 15.4 1.5 11.5 1.5C7.6 1.5 4.5 4.6 4.5 8.5C4.5 12.4 11.5 22.5 11.5 22.5C11.5 22.5 18.5 12.4 18.5 8.5Z"
      stroke="#666666"
    />
  </svg>
);

export default PoiMarker;
